export const getSx = (successButton) => {
  return {
    title: { my: '10px' },
    subTitleContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    subTitle: {
      color: '#000',
      mt: '20px',
      fontWeight: 600,
      textAlign: 'center',
      fontSize: '24px',
    },
    subText: {
      color: '#687F89',
      margin: '12px 0 8px 0',
      fontSize: '17px',
      fontWeight: successButton ? 400 : 500,
      textAlign: 'center',
    },
    buttonWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    button: {
      borderRadius: '40px',
      height: '56px',
      // width: '150px',
      width: '45%',
      py: '8px',
      color: '#ffffff',
      marginTop: '10px',
      backgroundColor: '#142C5C',
      '&:hover': { backgroundColor: '#142C5C', border: 'none', color: '#ffffff' },
    },
    cancelButton: {
      color: '#ffffff',
      borderRadius: '40px',
      border: 'none',
      height: '56px',
      backgroundColor: '#142C5C',
      '&:hover': { backgroundColor: '#142C5C', border: 'none', color: '#ffffff' },
    },
  };
};
